import React, { useEffect, useState } from 'react'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { DateRange } from 'react-date-range'
import { createNewDateRange, removeLastDateRange } from "../utils/dateRangeUtils";
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import ProcessController from "../components/process-controller"
import ImagesUploader from "../components/images-uploader"
import { handleImageUrl } from "../helpers";
import TextEditor from "../components/text-editor"
import FormControl from "@mui/material/FormControl";
import {Checkbox, FormControlLabel, FormGroup, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import {axios} from "../axios";
import {useNavigate, useParams} from "react-router-dom";

// Existing uploads keep their stored path (sent back as existing_*) apart from the display URL
const fileUrlsToUploaderData = (paths)=>{
    return (paths || []).filter(p => p && p !== 'none_images').map(path => ({
        path,
        url: handleImageUrl(path),
    }))
}

const EditOtherTour = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [meetingPointText,setMeetingPointText] = useState('')
    const [formData,setFormData] = useState({
        title_en:'',
        title_de:'',
        description_en:'',
        description_de:'',
        key_words_en:'',
        key_words_de:'',
        country:'',
        city_en:'',
        city_de:'',
        text_en:'',
        text_de:'',
        travel_info_en:'',
        travel_info_de:'',
        inclusions_en:'',
        inclusions_de:'',
        price:'',
        images:[],
        thumbnail:[],
        meeting: 10,
        meeting_text_en: '',
        meeting_text_de: '',
        meeting_des_en:'',
        meeting_des_de:'',
        starting_time: '',
        duration_day: '',
        duration_hour: '',
        duration_minute: '',
        discount:'',
        main_page: false,
        guest_min:'',
        guest_max:'1',
        child_price: '',
    })
    const [section, setSection] = React.useState('1');
    const [availableDates,setAvailableDates] = useState({})
    const [unAvailableDates,setUnAvailableDates] = useState({})
    const [week, setWeek] = React.useState({
        "0": false,
        "1": false,
        "2": false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
    });
    const handleWeekDay = (event) => {
        setWeek({
            ...week,
            [event.target.name]: event.target.checked,
        });
    };
    const [submitProcess,setSubmitProcess] = useState('none')
    const [errors,setErrors] = useState([])
    const [langs, setLangs] = useState({
        armenian: false,
        english: false,
        german: false,
        spanish: false,
        french: false,
        italy: false,
        portugal: false,
    });
    const handleLangs = (event) => {
        setLangs({
            ...langs,
            [event.target.name]: event.target.checked,
        });
    };
    const handleChange = (name,value)=>{
        setFormData({...formData,[name]: value})
    }
    const removeNewAvailableDate = () => {
        setAvailableDates(removeLastDateRange(availableDates));
    }
    const addNewAvailableDate = () => {
        setAvailableDates(createNewDateRange(availableDates, false));
    }
    const handleDates = () => {
        let data = []
        for(let e in availableDates){
            data.push(availableDates[e])
        }
        return data
    }
    const removeNewAvailableDate2 = () => {
        setUnAvailableDates(removeLastDateRange(unAvailableDates));
    }
    const addNewAvailableDate2 = () => {
        setUnAvailableDates(createNewDateRange(unAvailableDates, true));
    }
    const handleDates2 = () => {
        let data = []
        for(let e in unAvailableDates){
            data.push(unAvailableDates[e])
        }
        return data
    }
    const handleSection = (event, newValue) => {
        setSection(newValue);
    };

    useEffect(()=>{
        // Prefill data from backend
        setSubmitProcess('load')
        const fetchBothLangs = async () => {
            try {
                const reqEn = axios.get(`en/other-tour/${params.id}`).catch(() => axios.get(`/other-tour/${params.id}?lang=en`))
                const reqDe = axios.get(`de/other-tour/${params.id}`).catch(() => axios.get(`/other-tour/${params.id}?lang=de`))
                const [resEn, resDe] = await Promise.all([reqEn, reqDe])
                const dEn = resEn?.data || {}
                const dDe = resDe?.data || {}
                setFormData(prev => ({
                    ...prev,
                    title_en: dEn.title_en || dEn.title || '',
                    title_de: dDe.title_de || dDe.title || '',
                    description_en: dEn.description_en ?? dEn.description ?? '',
                    description_de: dDe.description_de ?? dDe.description ?? '',
                    key_words_en: (dEn.key_words_en ?? dEn.keywords_en ?? dEn.key_words ?? dEn.keywords ?? ''),
                    key_words_de: (dDe.key_words_de ?? dDe.keywords_de ?? dDe.key_words ?? dDe.keywords ?? ''),
                    country: dEn.country ?? dDe.country ?? '',
                    city_en: dEn.city_en ?? dEn.city ?? '',
                    city_de: dDe.city_de ?? dDe.city ?? '',
                    text_en: dEn.text_en ?? dEn.text ?? '',
                    text_de: dDe.text_de ?? dDe.text ?? '',
                    travel_info_en: dEn.travel_info_en ?? dEn.travel_info ?? '',
                    travel_info_de: dDe.travel_info_de ?? dDe.travel_info ?? '',
                    inclusions_en: dEn.inclusions_en ?? dEn.inclusions ?? '',
                    inclusions_de: dDe.inclusions_de ?? dDe.inclusions ?? '',
                    price: dEn.price ?? dDe.price ?? '',
                    meeting: dEn.meeting ?? dDe.meeting ?? 10,
                    meeting_text_en: dEn.meeting_text_en ?? dEn.meeting_text ?? '',
                    meeting_text_de: dDe.meeting_text_de ?? dDe.meeting_text ?? '',
                    meeting_des_en: dEn.meeting_des_en ?? dEn.meeting_des ?? '',
                    meeting_des_de: dDe.meeting_des_de ?? dDe.meeting_des ?? '',
                    starting_time: dEn.starting_time ?? dDe.starting_time ?? '',
                    duration_day: dEn.duration_day ?? dDe.duration_day ?? '',
                    duration_hour: dEn.duration_hour ?? dDe.duration_hour ?? '',
                    duration_minute: dEn.duration_minute ?? dDe.duration_minute ?? '',
                    discount: dEn.discount ?? dDe.discount ?? '',
                    main_page: !!(dEn.main_page ?? dDe.main_page),
                    guest_min: dEn.guest_min ?? dDe.guest_min ?? '',
                    guest_max: dEn.guest_max ?? dDe.guest_max ?? '1',
                    child_price: dEn.child_price ?? dDe.child_price ?? '',
                }))
                // languages
                let langsArr = []
                const rawLangs = dEn.languages ?? dDe.languages
                if (Array.isArray(rawLangs)) langsArr = rawLangs; else if (typeof rawLangs === 'string') { try { const parsed = JSON.parse(rawLangs); if (Array.isArray(parsed)) langsArr = parsed } catch(_) { langsArr = rawLangs.split(',').map(s=>s.trim()).filter(Boolean) } }
                if (langsArr.length) { const newLangs = {...langs}; langsArr.forEach(l => { if (newLangs[l] !== undefined) newLangs[l] = true }); setLangs(newLangs) }
                // Available dates — handle both already-parsed object (MySQL json column)
                // and raw JSON string (MySQL text column) from the API response.
                const dDates = (dEn && dEn.available_dates) ? dEn.available_dates : dDe.available_dates
                if (dDates) {
                    let parsedDates = null
                    try {
                        parsedDates = typeof dDates === 'string' ? JSON.parse(dDates) : dDates
                    } catch (_) {}
                    if (parsedDates && typeof parsedDates === 'object') {
                        const obj = {}
                        let idx = 1
                        Object.values(parsedDates).forEach(r => {
                            obj[`selection${idx}`] = {
                                startDate: new Date(r.startDate || r.start),
                                endDate:   new Date(r.endDate   || r.end),
                                key: `selection${idx}`,
                            }
                            idx++
                        })
                        setAvailableDates(obj)
                    }
                }
                // Unavailable dates — same dual-format handling
                const dUDates = (dEn && dEn.un_available_dates) ? dEn.un_available_dates : dDe.un_available_dates
                if (dUDates) {
                    let parsedUDates = null
                    try {
                        parsedUDates = typeof dUDates === 'string' ? JSON.parse(dUDates) : dUDates
                    } catch (_) {}
                    if (parsedUDates && typeof parsedUDates === 'object') {
                        const obj2 = {}
                        let idx2 = 1
                        Object.values(parsedUDates).forEach(r => {
                            obj2[`selection${idx2}`] = {
                                startDate: new Date(r.startDate || r.start),
                                endDate:   new Date(r.endDate   || r.end),
                                key: `selection${idx2}`,
                                color: 'brown'
                            }
                            idx2++
                        })
                        setUnAvailableDates(obj2)
                    }
                }
                // meeting handling
                const meetingVal = dEn.meeting ?? dDe.meeting
                const predefinedMeetings = ['Meeting Point','Hotel pick up','Hotel pick up & drop off','At the accommodation','At the airport']
                if (meetingVal) {
                    if (predefinedMeetings.includes(meetingVal)) { setFormData(f => ({...f, meeting: meetingVal})); if (meetingVal !== 'Meeting Point') setMeetingPointText('') } else { setFormData(f => ({...f, meeting: 'Meeting Point'})); setMeetingPointText(String(meetingVal)) }
                }
                // available weekdays: JSON array ("[1,3,5]"), array, or "1,3,5" / "1;3;5"
                const aw = dEn.available_weekdays ?? dDe.available_weekdays
                if (aw) {
                    let awArr = []
                    if (Array.isArray(aw)) {
                        awArr = aw
                    } else {
                        try {
                            const parsedAw = JSON.parse(aw)
                            awArr = Array.isArray(parsedAw) ? parsedAw : String(aw).split(/[;,]/)
                        } catch (_) {
                            awArr = String(aw).split(/[;,]/)
                        }
                    }
                    const w = {"0":false,"1":false,"2":false,"3":false,"4":false,"5":false,"6":false}
                    awArr.forEach(k => { const key = String(k).trim(); if (w[key] !== undefined) w[key] = true })
                    setWeek(w)
                }

                // images/thumbnail
                const thumb = dEn.thumbnail ?? dDe.thumbnail
                if (thumb) {
                    const thumbArr = Array.isArray(thumb) ? thumb : String(thumb).split(',').filter(Boolean)
                    setFormData(f => ({...f, thumbnail: fileUrlsToUploaderData(thumbArr)}))
                }
                const imgs = dEn.images ?? dDe.images
                if (imgs) {
                    const imgsArr = Array.isArray(imgs) ? imgs : String(imgs).split(',').filter(Boolean)
                    setFormData(f => ({...f, images: fileUrlsToUploaderData(imgsArr)}))
                }
                setSubmitProcess('none')
            } catch (e) {
                setSubmitProcess('none')
            }
        }
        fetchBothLangs()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[params.id])

    const validateForm = ()=>{
        if(!(formData.title_en || '').trim()){
            setErrors(['title_en']);
            return false;
        }
        setErrors([]);
        return true;
    }
    const textLengthValidate = () => {
        let errorsList = []
        if(formData.title_en.length > 60){ errorsList.push('title_en') }
        if(formData.title_de.length > 60){ errorsList.push('title_de'); setSubmitProcess('text length error') }
        if(formData.description_en.length > 160){ errorsList.push('description_en'); setSubmitProcess('text length error') }
        if(formData.description_de.length > 160){ errorsList.push('description_de'); setSubmitProcess('text length error') }
        setErrors(errorsList)
        return errorsList.length === 0;
    }
    const handleSubmit = ()=>{
        if(!validateForm()){
            setSubmitProcess('error')
            return false
        }
        if(!textLengthValidate()){
            setSubmitProcess('error-text-length')
            return false
        }
        const weekDays = Object.keys(week).reduce((acc, key) => { if (week[key] === true) { acc.push(key); } return acc; }, []);
        setSubmitProcess('load')
        const laguages = Object.entries(langs)
            .filter(([_, value]) => value === true)
            .map(([key]) => key);
        const languagesStr = laguages.join(',')
        let fd = new FormData()
        fd.append('title_en',formData.title_en)
        fd.append('title_de',formData.title_de)
        fd.append('description_en',formData.description_en)
        fd.append('description_de',formData.description_de)
        // Use backend field names (keywords_*)
        fd.append('key_words_en',formData.key_words_en)
        fd.append('key_words_de',formData.key_words_de)
        fd.append('country',formData.country)
        fd.append('city_en',formData.city_en)
        fd.append('city_de',formData.city_de)
        fd.append('text_en',formData.text_en)
        fd.append('text_de',formData.text_de)
        fd.append('travel_info_en',formData.travel_info_en)
        fd.append('travel_info_de',formData.travel_info_de)
        fd.append('inclusions_en',formData.inclusions_en)
        fd.append('inclusions_de',formData.inclusions_de)
        fd.append('price',formData.price)
        // Managed sets: the API keeps existing_images[] that are still shown, adds the new
        // images[] and deletes only what was removed
        fd.append('images_managed', '1')
        const imageItems = formData.images || []
        imageItems.forEach(el => {
            if (el.file) fd.append('images[]', el.file)
            else if (el.path) fd.append('existing_images[]', el.path)
        })
        fd.append('thumbnail_managed', '1')
        const thumbItem = (formData.thumbnail || [])[0]
        if (thumbItem?.file) fd.append('thumbnail', thumbItem.file)
        else if (thumbItem?.path) fd.append('existing_thumbnail', thumbItem.path)
        fd.append('meeting',formData.meeting === 'Meeting Point' ? meetingPointText : formData.meeting)
        fd.append('meeting_text_en',formData.meeting_text_en)
        fd.append('meeting_text_de',formData.meeting_text_de)
        fd.append('meeting_des_en',formData.meeting_des_en)
        fd.append('meeting_des_de',formData.meeting_des_de)
        fd.append('starting_time',formData.starting_time)
        fd.append('duration_day',formData.duration_day)
        fd.append('duration_hour',formData.duration_hour)
        fd.append('duration_minute',formData.duration_minute)
        fd.append('discount',formData.discount)
        fd.append('main_page',formData.main_page)
        fd.append('guest_min',formData.guest_min)
        fd.append('guest_max',formData.guest_max)
        fd.append('child_price',formData.child_price)
        fd.append('available_dates',JSON.stringify(availableDates))
        fd.append('un_available_dates',JSON.stringify(unAvailableDates))
        fd.append('available_weekdays',JSON.stringify(weekDays.map(Number)))
        fd.append('languages',languagesStr)
        axios.post(`/other-tour/${params.id}`,fd)
            .then(res => {
                if(res.data === 'updated' || res.data?.message === 'updated'){
                    setSubmitProcess('updated')
                }else{
                    setSubmitProcess('error')
                }
            })
            .catch(()=> setSubmitProcess('error'))
    }

    const handleDelete = ()=>{
        // eslint-disable-next-line no-restricted-globals
        const c = confirm('Delete this tour?')
        if(!c) return
        setSubmitProcess('load')
        axios.delete(`/other-tour/${params.id}`)
            .then(res=>{
                if(res.data?.message === 'deleted' || res.status === 200){
                    alert('Deleted successfully')
                    navigate('/other-tours')
                }else{
                    setSubmitProcess('error')
                }
            })
            .catch(()=> setSubmitProcess('error'))
    }

    return (
        <div className='main-container'>
            <ProcessController
                setSubmitProcess={setSubmitProcess}
                submitProcess={submitProcess}
                locationPath='/other-tours'
                handleSubmit={handleSubmit}
            />
            <div className='container mt-3'>
                <div className='d-flex justify-content-end'>
                    <button className='btn btn-danger' onClick={handleDelete}>Delete</button>
                </div>
            </div>
            <TabContext  value={section}>
                <Box sx={{ borderBottom: 1, borderColor: 'black',backgroundColor:'#0a5f9d',color:"white" }}>
                    <TabList onChange={handleSection} aria-label="lab API tabs example" >
                        <Tab label="SEO" value="1" style={{color:'white'}}/>
                        <Tab label="Countries" value="2" style={{color:'white'}}/>
                        <Tab label="Details" value="3" style={{color:'white'}}/>
                        <Tab label="More Details" value="4" style={{color:'white'}}/>
                        <Tab label="Images" value="5" style={{color:'white'}}/>
                        <Tab label="Price" value="7" style={{color:'white'}}/>
                        <Tab label="Availability" value="6" style={{color:'white'}}/>
                    </TabList>
                </Box>
                <div className="add-post mt-3 form">
                    <div className="container">
                        <TabPanel value="1" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container require ${errors.includes('title_en') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Title *</h6>
                                        <input  value={formData.title_en} onChange={e => handleChange('title_en',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container require ${errors.includes('title_de') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Title (German) *</h6>
                                        <input  value={formData.title_de} onChange={e => handleChange('title_de',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className={`col-6 require ${errors.includes('description_en') ? 'error' : ''}`}>
                                    <div className='text-editor'>
                                        <h6 className='title-label'>Description</h6>
                                        <textarea
                                            rows='6'
                                            placeholder='max length 120 letters'
                                            onChange={ e => handleChange('description_en', e.target.value)} value={formData.description_en}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className={`col-6 require ${errors.includes('description_de') ? 'error' : ''}`}>
                                    <div className='text-editor'>
                                        <h6 className='title-label'>Description (German)</h6>
                                        <textarea
                                            rows='6'
                                            placeholder='max length 120 letters'
                                            onChange={ e => handleChange('description_de', e.target.value)} value={formData.description_de}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 ${errors.includes('key_words_en') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Key Words</h6>
                                        <input
                                            value={formData.key_words_en}
                                            onChange={ e => handleChange('key_words_en', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters'}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 ${errors.includes('key_words_de') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Key Words (German)</h6>
                                        <input
                                            value={formData.key_words_de}
                                            onChange={ e => handleChange('key_words_de', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="2" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Country</h6>
                                        <FormControl fullWidth>
                                            <input value={formData.country} onChange={e => handleChange('country',e.target.value)} type="text"/>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require ${errors.includes('city_en') ? 'error' : ''}`}>
                                        <h6 className='title-label'>City</h6>
                                        <input
                                            value={formData.city_en}
                                            onChange={ e => handleChange('city_en', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require ${errors.includes('city_de') ? 'error' : ''}`}>
                                        <h6 className='title-label'>City (German)</h6>
                                        <input
                                            value={formData.city_de}
                                            onChange={ e => handleChange('city_de', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="3" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className={`col-6 require ${errors.includes('text_en') ? 'error' : ''}`}>
                                    <TextEditor value={formData.text_en} handleChange={handleChange} name='text_en' title='Text *'/>
                                </div>
                                <div className={`col-6 require ${errors.includes('text_de') ? 'error' : ''}`}>
                                    <TextEditor value={formData.text_de} handleChange={handleChange} name='text_de' title='Text (German) *'/>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className={`col-6 require ${errors.includes('travel_info_en') ? 'error' : ''}`}>
                                    <TextEditor value={formData.travel_info_en} handleChange={handleChange} name='travel_info_en' title='Information for travellers'/>
                                </div>
                                <div className={`col-6 require ${errors.includes('travel_info_de') ? 'error' : ''}`}>
                                    <TextEditor value={formData.travel_info_de} handleChange={handleChange} name='travel_info_de' title='Information for travellers (German)'/>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Inclusions</h6>
                                        <input
                                            value={formData.inclusions_en}
                                            onChange={ e => handleChange('inclusions_en', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters...'}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Inclusions (German)</h6>
                                        <input
                                            value={formData.inclusions_de}
                                            onChange={ e => handleChange('inclusions_de', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters...'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Language Options</h6>
                                        <div className="d-flex">
                                            <FormControlLabel control={<Checkbox checked={langs.armenian} onChange={handleLangs} name="armenian"/>} label="Armenian" />
                                            <FormControlLabel control={<Checkbox checked={langs.english} onChange={handleLangs} name="english"/>} label="English" />
                                            <FormControlLabel control={<Checkbox checked={langs.german} onChange={handleLangs} name="german"/>} label="German" />
                                            <FormControlLabel control={<Checkbox checked={langs.spanish} onChange={handleLangs} name="spanish"/>} label="Spanish" />
                                            <FormControlLabel control={<Checkbox checked={langs.french} onChange={handleLangs} name="french"/>} label="French" />
                                            <FormControlLabel control={<Checkbox checked={langs.italy} onChange={handleLangs} name="italy"/>} label="Italian" />
                                            <FormControlLabel control={<Checkbox checked={langs.portugal} onChange={handleLangs} name="portugal"/>} label="Portuguese" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="4" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Meeting</h6>
                                        <FormControl fullWidth>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={formData.meeting}
                                                label="Meeting point"
                                                onChange={e => handleChange('meeting',e.target.value)}
                                            >
                                                <MenuItem value={'Meeting Point'}>Meeting Point</MenuItem>
                                                <MenuItem value={'Hotel pick up'}>Hotel pick up</MenuItem>
                                                <MenuItem value={'Hotel pick up & drop off'}>Hotel pick up & drop off</MenuItem>
                                                <MenuItem value={'At the accommodation'}>At the accommodation</MenuItem>
                                                <MenuItem value={'At the airport'}>At the airport</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {formData.meeting === 'Meeting Point' && <input
                                            value={meetingPointText}
                                            onChange={e => setMeetingPointText(e.target.value)}
                                            type="text"
                                            placeholder={'Meeting point text...'}
                                            className='mt-2'
                                        />}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require`}>
                                        <h6 className='title-label text-center'>Main Page</h6>
                                        <input type="checkbox" className='checkbox' checked={!!formData.main_page} onChange={e => handleChange('main_page',e.target.checked)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Meeting text</h6>
                                        <input
                                            value={formData.meeting_text_en}
                                            onChange={ e => handleChange('meeting_text_en', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters...'}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Meeting text (German)</h6>
                                        <input
                                            value={formData.meeting_text_de}
                                            onChange={ e => handleChange('meeting_text_de', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters...'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Describe the meeting point</h6>
                                        <input
                                            value={formData.meeting_des_en}
                                            onChange={ e => handleChange('meeting_des_en', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters...'}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Describe the meeting point (German)</h6>
                                        <input
                                            value={formData.meeting_des_de}
                                            onChange={ e => handleChange('meeting_des_de', e.target.value) }
                                            type="text"
                                            placeholder={'max length 60 letters...'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="5">
                            <div className="row mb-3">
                                <div className={`col-6`}>
                                    <ImagesUploader data={formData.thumbnail} handleImages={handleChange} name='thumbnail' title='Thumbnail' multiple={false}/>
                                </div>
                                <div className={`col-6`}>
                                    <ImagesUploader data={formData.images} handleImages={handleChange} name='images' title='Images' multiple={true}/>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="6">
                            <div className="row mb-3">
                                <div className="col-4">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='ms-1 title-label'>Duration</h6>
                                        <div className="d-flex">
                                            <input className='mx-1' type='number' placeholder='Days' value={formData.duration_day} onChange={ e => handleChange('duration_day',e.target.value) } />
                                            <input className='mx-1' type='number' placeholder='Hours' value={formData.duration_hour} onChange={ e => handleChange('duration_hour',e.target.value) } />
                                            <input className='mx-1' type='number' placeholder='Minutes' value={formData.duration_minute} onChange={ e => handleChange('duration_minute',e.target.value) } />
                                        </div>
                                    </div>
                                    <div className={`input-container mb-3 require`}>
                                        <h6 className='title-label'>Starting time </h6>
                                        <input type="text" value={formData.starting_time} onChange={e => handleChange('starting_time',e.target.value)} />
                                    </div>
                                    <div className='input-container'>
                                        <Box sx={{ display: 'flex' }}>
                                            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                                                <FormGroup>
                                                    <div className="d-flex">
                                                        <div className="d-flex flex-column">
                                                            <FormControlLabel control={<Checkbox checked={week["1"]} onChange={handleWeekDay} name="1" />} label="Monday" />
                                                            <FormControlLabel control={<Checkbox checked={week["2"]} onChange={handleWeekDay} name="2" />} label="Tuesday" />
                                                            <FormControlLabel control={<Checkbox checked={week["3"]} onChange={handleWeekDay} name="3" />} label="Wednesday" />
                                                            <FormControlLabel control={<Checkbox checked={week["4"]} onChange={handleWeekDay} name="4" />} label="Thursday" />
                                                        </div>
                                                        <div className="d-flex flex-column">
                                                            <FormControlLabel control={<Checkbox checked={week["5"]} onChange={handleWeekDay} name="5" />} label="Friday" />
                                                            <FormControlLabel control={<Checkbox checked={week["6"]} onChange={handleWeekDay} name="6" />} label="Saturday" />
                                                            <FormControlLabel control={<Checkbox checked={week["0"]} onChange={handleWeekDay} name="0" />} label="Sunday" />
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                            </FormControl>
                                        </Box>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Available dates </h6>
                                        <DateRange editableDateInputs={true} onChange={item => setAvailableDates({ ...availableDates, ...item })} ranges={[...handleDates()]} />
                                        <div className="d-flex mt-3">
                                            <button onClick={addNewAvailableDate} className='btn btn-success me-2'>+</button>
                                            <button className='btn btn-danger' onClick={removeNewAvailableDate}>-</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className={`input-container mb-3 require `}>
                                        <h6 className='title-label'>Unavailable dates </h6>
                                        <DateRange editableDateInputs={true} onChange={item => setUnAvailableDates({ ...unAvailableDates, ...item })} ranges={[...handleDates2()]} />
                                        <div className="d-flex mt-3">
                                            <button onClick={addNewAvailableDate2} className='btn btn-success me-2'>+</button>
                                            <button className='btn btn-danger' onClick={removeNewAvailableDate2}>-</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="7">
                            <div className="row">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require ${errors.includes('price') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Price *</h6>
                                        <input value={formData.price} onChange={ e => handleChange('price', e.target.value) } type="number" min='1' placeholder={'Price ( $ )'} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require col-12`}>
                                        <h6 className='title-label'>Child Price</h6>
                                        <input value={formData.child_price} onChange={ e => handleChange('child_price', e.target.value) } type="number" min='1' placeholder={'Child price ( % )'} />
                                    </div>
                                </div>
                            </div>
                            <div className={`input-container mb-3 require col-12`}>
                                <h6 className='title-label'>Discount </h6>
                                <input value={formData.discount} onChange={ e => handleChange('discount', e.target.value) } type="number" min='1' placeholder={'Discount ( % )'} />
                            </div>
                            <div className="d-flex">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require ${errors.includes('guest_min') ? 'error' : ''}`}>
                                        <h6 className='title-label text-center'>Guest min count</h6>
                                        <input value={formData.guest_min} onChange={ e => handleChange('guest_min', e.target.value) } type="number" min='1' />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 require ${errors.includes('guest_max') ? 'error' : ''}`}>
                                        <h6 className='title-label text-center'>Main max count </h6>
                                        <input value={formData.guest_max} style={{fontSize:'14px'}} onChange={ e => handleChange('guest_max', e.target.value) } type="number" min='1' />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </div>
                </div>
            </TabContext>
        </div>
    );
};

export default EditOtherTour;
